import RadioCards from '@/common/components/RadioCards'
import CreateForwardingDirectiveEntryFormStepAccordion from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/components/CreateForwardingDirectiveEntryFormStepAccordion'
import { establishmentChoiceEntryOptions } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/establishmentChoiceEntry/establishmentChoiceEntryOptions.constant'
import {
  MaintenanceForwardingsDirectiveFromSteps,
  MaintenanceForwardingsEstablishmentChoiceEntryStepOptions,
} from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsShowDirectiveDetails.type'
import { EstablishmentChoiceEntryValidationSchema } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/schemas/maintenanceForwardingDirectiveSteps.schema'
import { useCreateForwardingsFormStore } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/stores/createForwardingsFormStore'
import { MaintenanceForwardingsDirectiveFormStepProps } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/types/maintenanceForwardingsDirectiveFormStep.type'
import { useMemo } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'

const EstablishmentChoiceEntryFormStepPending = ({
  state,
  attributes,
}: MaintenanceForwardingsDirectiveFormStepProps<MaintenanceForwardingsDirectiveFromSteps.EstablishmentChoiceEntry>) => {
  const { control, setValue } = useFormContext<EstablishmentChoiceEntryValidationSchema>()

  const { setUpdatedValueAt } = useCreateForwardingsFormStore()

  const { establishment_choice_entry_type: watchEstablishmentChoiceEntryType } = useWatch({
    control,
  })

  const EntryOptionComponent = useMemo(() => {
    if (watchEstablishmentChoiceEntryType) {
      const establishmentChoiceOption =
        establishmentChoiceEntryOptions[
          watchEstablishmentChoiceEntryType as MaintenanceForwardingsEstablishmentChoiceEntryStepOptions
        ]

      return establishmentChoiceOption.components.pending
    }

    return null
  }, [watchEstablishmentChoiceEntryType])

  return (
    <CreateForwardingDirectiveEntryFormStepAccordion
      state={state}
      title="Método de escolha do estabelecimento"
      body={
        <div>
          {!watchEstablishmentChoiceEntryType && (
            <RadioCards
              options={(attributes as MaintenanceForwardingsEstablishmentChoiceEntryStepOptions[])
                ?.filter((option) => !!establishmentChoiceEntryOptions[option])
                ?.map((option) => {
                  const establishmentChoiceOption = establishmentChoiceEntryOptions[option]

                  return {
                    value: option,
                    title: establishmentChoiceOption.title,
                    description: establishmentChoiceOption.description,
                  }
                })}
              value={watchEstablishmentChoiceEntryType}
              onValueChange={(value) => {
                setUpdatedValueAt()
                setValue('establishment_choice_entry_type', value)
              }}
            />
          )}

          {watchEstablishmentChoiceEntryType && EntryOptionComponent && <EntryOptionComponent />}
        </div>
      }
    />
  )
}

export default EstablishmentChoiceEntryFormStepPending
